var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/CLone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic-copy/Outlined",
    transform: "translate(9, 9) scale(-1, 1) translate(-9, -9)translate(2.3333, 2.3333)",
    fill: "#0A186E",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(0, -0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,2.20000025 C13.3333333,0.984973907 12.3483602,0 11.1333333,0 L6.2,0 C4.98497365,0 4,0.984973399 4,2.2 L4,2.33333333 C4,2.70152308 4.29847666,3 4.66666667,3 C5.03485667,3 5.33333333,2.70152308 5.33333333,2.33333333 L5.33333333,2.2 C5.33333333,1.72135315 5.72135315,1.33333333 6.2,1.33333333 L11.1333333,1.33333346 C11.6119802,1.33333359 12,1.7213534 12,2.20000025 L12,7.13333333 C12,7.61198018 11.6119802,8 11.1333333,8 L11,8 C10.6318095,8 10.3333333,8.29847666 10.3333333,8.66666667 C10.3333333,9.03485718 10.6318095,9.33333333 11,9.33333333 L11.1333333,9.33333333 C12.3483592,9.33333333 13.3333333,8.34836019 13.3333333,7.13333384 L13.3333333,2.20000025 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,4 C0.984973526,4 0,4.98497416 0,6.20000051 L0,11.1333333 C0,12.3483602 0.984973526,13.3333333 2.2,13.3333333 L7.13333333,13.3333333 C8.34835968,13.3333333 9.33333333,12.3483602 9.33333333,11.1333333 L9.33333333,6.20000051 C9.33333333,4.98497416 8.34835968,4 7.13333333,4 L2.2,4 Z M1.33333333,6.20000051 C1.33333333,5.72135366 1.72135315,5.33333384 2.2,5.33333384 L7.13333333,5.33333384 C7.61198018,5.33333384 8,5.72135366 8,6.20000051 L8,11.1333333 C8,11.6119812 7.61198018,12 7.13333333,12 L2.2,12 C1.72135315,12 1.33333333,11.6119812 1.33333333,11.1333333 L1.33333333,6.20000051 Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clone.6bdd7cd038d4006124fe7680de232ef8.svg";